<template>
  <section class="professional-projects">
    <!-- Professinal Projects Title-->
    <div class="page-container">
      <div class="title-container" id="professional-projects">
        <img class="title-icon" src="@/assets/navbar/professional_icon.png" alt="Icon">
        <h1 class="title">{{ $t('professional-projects.professional-projects') }}</h1>
      </div>
    </div>

    <GamesCarousel :games="ProfessionalGames" />

  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import ProfessionalGamesEn from '@/components/Helpers/ProfessionalGames/ProfessionalGamesEn.js';
import ProfessionalGamesPt from '@/components/Helpers/ProfessionalGames/ProfessionalGamesPt.js';
import GamesCarousel from '@/components/Helpers/GamesCarousel.vue';

const ProfessionalGames = ref(null);

onMounted(() => {
  checkLanguage();
});

function checkLanguage() {
  const userLanguage = navigator.language || navigator.userLanguage;

  if (userLanguage.startsWith("pt")) {
    ProfessionalGames.value = ProfessionalGamesPt;
  }
  else {
    ProfessionalGames.value = ProfessionalGamesEn;
  }
}
</script>

<style lang="scss" scoped>
@import '~/src/assets/css/ProjectsHeaderStyle.scss';

.professional-projects {
  margin-top: 900px;
  background-color: #212121;
  margin-left: -8px;
  margin-right: -8px;
  margin-bottom: -10px;
  padding-bottom: 20px;
}
</style>